/**
 * Namespaced browser storage keys. Prefer these helpers over raw localStorage strings
 * so native apps can substitute secure storage later.
 */

export const STORAGE_KEYS = {
  celebratedFirstSession: 'swish_celebrated_first_session',
  flowModePreferred: 'swish_flow_mode_preferred',
  flowModeOptInCount: 'swish_flow_mode_optin_count',
  flowSessionsCompleted: 'swish_flow_sessions_completed',
  flowModeUsed: 'swish_flow_mode_used',
  flowRepLoggingFamiliar: 'swish_flow_rep_logging_familiar',
  flowDemoUsageCount: 'swish_flow_demo_usage_count',
  flowManualOverride: 'swish_flow_manual_override',
} as const

export function safeLocalStorageAvailable(): boolean {
  return typeof localStorage !== 'undefined'
}

export function storageGet(key: string): string | null {
  if (!safeLocalStorageAvailable()) return null
  try {
    return localStorage.getItem(key)
  } catch {
    return null
  }
}

export function storageSet(key: string, value: string): void {
  if (!safeLocalStorageAvailable()) return
  try {
    localStorage.setItem(key, value)
  } catch {
    /* quota / privacy mode */
  }
}
